// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".botaoConfig.saib-button.is-circle{\n  padding: 18px!important;\n}\n\ndiv h4{\n  padding-top: 0px!important;\n}\n\n.btn.waves-effect.waves-light.saib-button.is-primary.modal-action.modal-close{\n  margin-left: 10px;\n}\n\n.hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n", ""]);
// Exports
module.exports = exports;
